/**
 * <ClassStatusTd
 * 		classInfo={classInfo Object}
 *	/>
 *
 *
 * @parent table in Student
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'

class ClassStatusTd extends React.Component {
  constructor(props) {
		super(props);
	}

  _getFeeType(classInfo) {
    return ['per_day', 'per_time', 'per_hour'][classInfo.feeType]
  }

  render() {
    const {classInfo} = this.props;

    if (!classInfo) {
      return <span />
    }

    const feeType = this._getFeeType(classInfo);

    let infoContent = '';

    let needToAlert = false;

    let { usedTotalQuantity: qty, paidTotalQuantity: total } = classInfo;

    switch (feeType) {
      case 'per_day':
        let { days_left, alertRange} = classInfo;

        if (days_left < 0) {
          days_left = 0;
        }

        if (days_left > 1) {
          infoContent = __('{days_left} days remaining', 'student.table', { days_left });
        } else if (days_left == 0) {
          infoContent = __('{days_left} day remaining', 'student.table', { days_left });
        } else if (days_left == 1){
          infoContent = __('{days_left} day remaining', 'student.table', { days_left });
        }

        if (days_left <= alertRange) {
          needToAlert = true;
        }
        break;
      case 'per_time':

        // if (total == 0 && qty == 0) {
        //   break;
        // }

        if (qty > 1) {
          infoContent = __('{qty} / {total} lessons', 'student.table', { qty, total });
        } else {
          infoContent = __('{qty} / {total} lesson', 'student.table', { qty, total });
        }

        if ((total - qty) <= classInfo.alertRange) {
          needToAlert = true;
        }
        break;
      case 'per_hour':
        // if (total == 0) {
        //   break;
        // }

        if (qty > 1) {
          infoContent = __('{qty} / {total} hours', 'student.table', { qty, total });
        } else {
          infoContent = __('{qty} / {total} hour', 'student.table', { qty, total });
        }

        if ((total - qty) <= classInfo.alertRange) {
          needToAlert = true;
        }
        break;
    }

    return (
      <div className='td-inner-content'>
        <span className={classnames('class-status', {'alert-text': needToAlert})}>
          {infoContent}
        </span>
      </div>
    )
  }
}

export default ClassStatusTd;



// WEBPACK FOOTER //
// ./src/containers/pages/Student/StudentTable/ClassStatusTd.js